import { render, staticRenderFns } from "./svgEdit.vue?vue&type=template&id=9c165832&scoped=true&"
import script from "./svgEdit.vue?vue&type=script&lang=js&"
export * from "./svgEdit.vue?vue&type=script&lang=js&"
import style0 from "./svgEdit.vue?vue&type=style&index=0&id=9c165832&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c165832",
  null
  
)

export default component.exports